import React, { useState, useEffect } from "react";
import { pageTitle } from "../../helpers/PageTitle";
import Section from "../Section";
import { FaFileAlt, FaArrowRight, FaCheckCircle } from "react-icons/fa";
import { MdCompareArrows, MdDelete } from "react-icons/md";
import axios from "axios";
import { API_URL } from "../../Config/environment";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
export default function PricingPlan() {
    pageTitle("Pricing Plan");
    const navigate = useNavigate();
    const [categories, setCategories] = useState([]);
    const [scanCategories, setScanCategories] = useState([]);
    const [labTestCategories, setLabTestCategories] = useState([]);
    const [packages, setPackages] = useState([]);
    const [activeHealth, setActiveHealth] = useState(""); // for health checks
    const [activeScan, setActiveScan] = useState("");
    const [activeLab, setActiveLab] = useState(""); // for scans
    const [loading, setLoading] = useState(true);
    const [compareList, setCompareList] = useState([]);

    console.log("activeHealth", activeHealth);
    console.log("packages", packages);

    const toggleCompare = (pack) => {
        let updated = [];

        if (compareList.find((p) => p.id === pack.id)) {
            updated = compareList.filter((p) => p.id !== pack.id);
        } else {
            // limit to 4 packages (optional)
            if (compareList.length >= 4) {
                alert("You can compare up to 4 packages only");
                return;
            }
            updated = [...compareList, pack];
        }

        setCompareList(updated);
        localStorage.setItem("compareHealthPackages", JSON.stringify(updated));
    };

    useEffect(() => {
        const loadAll = async () => {
            setLoading(true);

            try {
                const [healthCatRes, scanCatRes, labCatRes, pkgRes] =
                    await Promise.all([
                        axios.get(
                            `${API_URL}/health-package/categories?category_type=health_checks`,
                        ),
                        axios.get(
                            `${API_URL}/health-package/categories?category_type=scans`,
                        ),
                        axios.get(
                            `${API_URL}/health-package/categories?category_type=lab_test`,
                        ),
                        axios.get(`${API_URL}/health-package/home-page?page=1&limit=1500`),
                    ]);

                // Health categories
                if (healthCatRes.data?.statusCode === 200) {
                    const list = healthCatRes.data.data.categories.map(
                        (cat) => ({
                            id: cat.id,
                            title: cat.title,
                            img: `${API_URL}/${cat.imageUrl}`,
                        }),
                    );
                    setCategories(list);

                    if (list.length > 0) setActiveHealth(list[0].title);
                }

                // Scan categories
                if (scanCatRes.data?.statusCode === 200) {
                    const scanList = scanCatRes.data.data.categories.map(
                        (cat) => ({
                            id: cat.id,
                            title: cat.title,
                            img: `${API_URL}/${cat.imageUrl}`,
                        }),
                    );
                    setScanCategories(scanList);

                    if (scanList.length > 0) setActiveScan(scanList[0].title);
                }

                if (labCatRes.data?.statusCode === 200) {
                    const labList = labCatRes.data.data.categories.map(
                        (cat) => ({
                            id: cat.id,
                            title: cat.title,
                            img: `${API_URL}/${cat.imageUrl}`,
                        }),
                    );
                    setLabTestCategories(labList);

                    if (labList.length > 0) setActiveLab(labList[0].title);
                }
                // Packages
                if (pkgRes.data?.statusCode === 200) {
                    setPackages(pkgRes.data.data.packages);
                }
            } catch (err) {
                console.error("Loading error: ", err);
            }

            setLoading(false);
        };

        loadAll();
    }, []);
    const filteredHealthPackages =
        activeHealth === ""
            ? packages // show all by default
            : packages.filter(
                (p) =>
                    p.category?.title?.toLowerCase() ===
                    activeHealth.toLowerCase(),
            );

    const filteredScanPackages =
        activeScan === ""
            ? packages
            : packages.filter(
                (p) =>
                    p.category?.title?.toLowerCase() ===
                    activeScan.toLowerCase(),
            );

    const filteredLabPackages =
        activeLab === ""
            ? packages
            : packages.filter(
                (p) =>
                    p.category?.title?.toLowerCase() ===
                    activeLab.toLowerCase(),
            );

    return (
        <Section topMd={150}
            topLg={70}
            topXl={105}>

            <div className="hero-banner11">
                <h1>GKC Klinica Health Packages</h1>
                <p>
                    Your Health, Our Priority — Get Comprehensive Tests at the
                    Best Prices
                </p>
            </div>

            <Section topMd={60} topLg={80} topXl={100} bottomMd={60} bottomLg={80} bottomXl={100}>
                {compareList.length > 0 && (
                    <div className="compare-actions-wrapper">

                        {/* 🔴 Reset Button */}
                        <button
                            onClick={() => setCompareList([])}
                            className="btn-reset-compare"
                        >
                            <MdDelete className="btn-icon" />
                            Clear
                        </button>

                        {/* 🟢 Compare Button */}
                        <button
                            onClick={() => {
                                localStorage.setItem(
                                    "compareHealthPackages",
                                    JSON.stringify(compareList)
                                );
                                navigate("/compare-health-packages");
                            }}
                            className="btn-compare-now"
                        >
                            Compare ({compareList.length})
                        </button>

                    </div>
                )}
                <section className="pricing-wrapper">
                    <h2 className="main-title">
                        Recommended Full Body Checkup
                    </h2>

                    {/* CATEGORY ROW */}
                    <div className="category-row">
                        {categories.map((cat) => (
                            <div
                                key={cat.id}
                                className={`category-item ${activeHealth === cat.title ? "active" : ""
                                    }`}
                                onClick={() => setActiveHealth(cat.title)}
                            >
                                <img src={cat.img} alt={cat.title} />
                                <p>{cat.title}</p>
                                {activeHealth === cat.title && (
                                    <span className="underline"></span>
                                )}
                            </div>
                        ))}
                    </div>

                    {/* HEALTH PACKAGES GRID */}
                    <div className="container my-5">
                        {filteredHealthPackages.length === 0 && (
                            <p className="no-data">No data found</p>
                        )}

                        <div className="row g-4 justify-content-center">
                            {filteredHealthPackages.map((pack) => {
                                const isSelected = compareList.some((p) => p.id === pack.id);

                                return (
                                    <div
                                        key={pack.id}
                                        className="col-12 col-sm-6 col-md-3 col-lg-3"
                                    >
                                        <div className="plan-card">

                                            {/* 🔥 Compare Button */}
                                            <div
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    toggleCompare(pack);
                                                }}
                                                className="compare-btn"
                                            >
                                                {isSelected ? (
                                                    <FaCheckCircle className="icon success" />
                                                ) : (
                                                    <MdCompareArrows className="icon" />
                                                )}
                                                <span>{isSelected ? "Added" : "Compare"}</span>
                                            </div>

                                            <h2>
                                                {pack.name} <span>{pack.discount}% OFF</span>
                                            </h2>

                                            <div className="etiquet-price">
                                                <p>{pack.price}</p>
                                                <div></div>
                                            </div>

                                            <div className="benefits-list">
                                                <ul>
                                                    <li>🧪 {pack.testCounts} Tests Included</li>
                                                    <li>
                                                        Reports in <strong>{pack.duration || "N/A"}</strong>
                                                    </li>
                                                </ul>
                                            </div>

                                            <div className="button-get-plan">
                                                <Link to={`/packages/${pack.id}`}>
                                                    <FaArrowRight className="svg-rocket" />
                                                    <span>Book Now</span>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>


                </section>

                <section className="pricing-wrapper">
                    <h2 className="main-title">Top Booked Lab Tests</h2>

                    {/* CATEGORY ROW */}
                    <div className="category-row">
                        {labTestCategories.map((cat) => (
                            <div
                                key={cat.id}
                                className={`category-item ${activeLab === cat.title ? "active" : ""
                                    }`}
                                onClick={() => setActiveLab(cat.title)}
                            >
                                <img src={cat.img} alt={cat.title} />
                                <p>{cat.title}</p>
                                {activeLab === cat.title && (
                                    <span className="underline"></span>
                                )}
                            </div>
                        ))}
                    </div>

                    {/* SCAN PACKAGES GRID */}
                    <div className="container my-5">
                        {filteredLabPackages.length === 0 && (
                            <p className="no-data">No data found</p>
                        )}

                        <div className="row g-4 justify-content-center">
                            {filteredLabPackages.map((pack) => {
                                const isSelected = compareList.some((p) => p.id === pack.id);

                                return (
                                    <div
                                        key={pack.id}
                                        className="col-12 col-sm-6 col-md-3 col-lg-3"
                                    >
                                        <div className="plan-card">

                                            {/* 🔥 Compare Button */}
                                            <div
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    toggleCompare(pack);
                                                }}
                                                className="compare-btn"
                                            >
                                                {isSelected ? (
                                                    <FaCheckCircle className="icon success" />
                                                ) : (
                                                    <MdCompareArrows className="icon" />
                                                )}
                                                <span>{isSelected ? "Added" : "Compare"}</span>
                                            </div>

                                            <h2>
                                                {pack.name} <span>{pack.discount}% OFF</span>
                                            </h2>

                                            <div className="etiquet-price">
                                                <p>{pack.price}</p>
                                                <div></div>
                                            </div>

                                            <div className="benefits-list">
                                                <ul>
                                                    <li>🧪 {pack.testCounts} Tests Included</li>
                                                    <li>
                                                        Reports in <strong>{pack.duration || "N/A"}</strong>
                                                    </li>
                                                </ul>
                                            </div>

                                            <div className="button-get-plan">
                                                <Link to={`/packages/${pack.id}`}>
                                                    <FaArrowRight className="svg-rocket" />
                                                    <span>Book Now</span>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>


                </section>

                <section className="pricing-wrapper">
                    <h2 className="main-title">Top Booked Health Scans</h2>
                    {/* CATEGORY ROW */}
                    <div className="category-row">
                        {scanCategories.map((cat) => (
                            <div
                                key={cat.id}
                                className={`category-item ${activeScan === cat.title ? "active" : ""
                                    }`}
                                onClick={() => setActiveScan(cat.title)}
                            >
                                <img src={cat.img} alt={cat.title} />
                                <p>{cat.title}</p>
                                {activeScan === cat.title && (
                                    <span className="underline"></span>
                                )}
                            </div>
                        ))}
                    </div>

                    {/* PACKAGES GRID */}
                    <div className="container my-5">
                        {filteredScanPackages.length === 0 && (
                            <p className="no-data">No data found</p>
                        )}

                        <div className="row g-4 justify-content-center">
                            {filteredScanPackages.map((pack) => {
                                const isSelected = compareList.some((p) => p.id === pack.id);

                                return (
                                    <div
                                        key={pack.id}
                                        className="col-12 col-sm-6 col-md-3 col-lg-3"
                                    >
                                        <div className="plan-card">

                                            {/* 🔥 Compare Button */}
                                            <div
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    toggleCompare(pack);
                                                }}
                                                className="compare-btn"
                                            >
                                                {isSelected ? (
                                                    <FaCheckCircle className="icon success" />
                                                ) : (
                                                    <MdCompareArrows className="icon" />
                                                )}
                                                <span>{isSelected ? "Added" : "Compare"}</span>
                                            </div>

                                            <h2>
                                                {pack.name} <span>{pack.discount}% OFF</span>
                                            </h2>

                                            <div className="etiquet-price">
                                                <p>{pack.price}</p>
                                                <div></div>
                                            </div>

                                            <div className="benefits-list">
                                                <ul>
                                                    <li>🧪 {pack.testCounts} Tests Included</li>
                                                    <li>
                                                        Reports in <strong>{pack.duration || "N/A"}</strong>
                                                    </li>
                                                </ul>
                                            </div>

                                            <div className="button-get-plan">
                                                <Link to={`/packages/${pack.id}`}>
                                                    <FaArrowRight className="svg-rocket" />
                                                    <span>Book Now</span>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </section>
            </Section>
        </Section>
    );
}
